[
  "accurate",
  "acquire",
  "ambitious",
  "analyze",
  "ancient",
  "approximate",
  "argue",
  "attitude",
  "authority",
  "benefit",
  "capacity",
  "category",
  "circumstance",
  "communicate",
  "concentrate",
  "conclude",
  "conflict",
  "consequence",
  "considerable",
  "consist",
  "construct",
  "contribute",
  "convince",
  "cooperate",
  "correspond",
  "demonstrate",
  "depict",
  "distinguish",
  "eliminate",
  "encounter",
  "evidence",
  "function",
  "hypothesis",
  "illustrate",
  "implement",
  "influence",
  "integrate",
  "interpret",
  "investigate",
  "justify",
  "maintain",
  "manipulate",
  "navigate",
  "participate",
  "perceive",
  "perspective",
  "persuade",
  "phenomenon",
  "predict",
  "procedure",
  "recommend",
  "regulate",
  "relevant",
  "research",
  "resources",
  "response",
  "significant",
  "specify",
  "strategy",
  "structure",
  "sufficient",
  "summarize",
  "symbolic",
  "technique",
  "technology",
  "tolerance",
  "transform",
  "transition",
  "undertake",
  "utilize",
  "interact",
  "interrupt",
  "interview",
  "international",
  "internal",
  "intermediate",
  "intercept",
  "interval",
  "interstate",
  "interconnect",
  "transport",
  "transfer",
  "translate",
  "transform",
  "transmit",
  "transparent",
  "transaction",
  "transcontinental",
  "transition",
  "transplant",
  "submarine",
  "subway",
  "submerge",
  "subtract",
  "subheading",
  "subdivide",
  "subplot",
  "subset",
  "substandard",
  "subtitle",
  "superhero",
  "supernatural",
  "supermarket",
  "supervise",
  "superior",
  "supersonic",
  "superpower",
  "superintendent",
  "superficial",
  "supernatural",
  "biology",
  "geology",
  "ecology",
  "psychology",
  "technology",
  "zoology",
  "archaeology",
  "mythology",
  "sociology",
  "theology",
  "geography",
  "biography",
  "photography",
  "paragraph",
  "autograph",
  "telegram",
  "phonograph",
  "bibliography",
  "autobiography",
  "topography",
  "thermometer",
  "barometer",
  "speedometer",
  "odometer",
  "perimeter",
  "diameter",
  "kilometer",
  "centimeter",
  "millimeter",
  "telescope",
  "microscope",
  "periscope",
  "stethoscope",
  "horoscope",
  "kaleidoscope",
  "hydroscope",
  "gyroscope",
  "telephone",
  "microphone",
  "saxophone",
  "megaphone",
  "xylophone",
  "symphony",
  "homophone",
  "phonics",
  "aquarium",
  "aquatic",
  "aqueduct",
  "aquamarine",
  "aquifer",
  "aquaplane",
  "audible",
  "audience",
  "audition",
  "auditorium",
  "audiobook",
  "audit",
  "benediction",
  "dictate",
  "dictionary",
  "predict",
  "contradict",
  "verdict",
  "jurisdiction",
  "edict",
  "manuscript",
  "script",
  "describe",
  "inscribe",
  "transcribe",
  "subscribe",
  "prescription",
  "scribble",
  "graphic",
  "photosynthesis",
  "chlorophyll",
  "chromosome",
  "ecosystem",
  "biodiversity",
  "symbiosis",
  "metamorphosis",
  "organism",
  "invertebrate",
  "vertebrate",
  "carnivore",
  "herbivore",
  "omnivore",
  "predator",
  "producer",
  "consumer",
  "decomposer",
  "evaporation",
  "condensation",
  "precipitation"
]
